import {
  useEntryLoader,
  useEventLoader,
  useGetEntries,
  useGetEvents,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { createAggregateLoadingContextProvider } from "./createAggregateLoadingContextProvider"
import {
  CollectionKey,
  UserLocalStorageKey,
} from "src/types"

export const [
  EventLoadingProvider,
  useEventLoading,
  useEventReloading,
] =
  createAggregateLoadingContextProvider(
    UserLocalStorageKey.EventsLoadedRanges,
    CollectionKey.UserEvent,
    useEventLoader,
    useGetEvents,
  )

export const [
  EntryLoadingProvider,
  useEntryLoading,
  useEntryReloading,
] =
  createAggregateLoadingContextProvider(
    UserLocalStorageKey.EntriesLoadedRanges,
    CollectionKey.UserEntry,
    useEntryLoader,
    useGetEntries,
  )
